module.exports = __webpack_public_path__ + "assets/pvh-logo-horizontal.b2be2df8.svg";